import { hangup } from '../../../react/features/base/connection/actions.web';
import { JitsiConferenceEvents } from '../../../react/features/base/lib-jitsi-meet';
import { MEDIA_TYPE, VIDEO_TYPE } from '../../../react/features/base/media/constants';
import { getLocalParticipant, getParticipantById, getParticipantCount } from '../../../react/features/base/participants/functions';
import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import { getLocalVideoTrack, getVideoTrackByParticipant, isLocalTrackMuted } from '../../../react/features/base/tracks/functions.any';
import { muteLocal } from '../../../react/features/video-menu/actions.any';
import { sendStatsToKibana } from '../analytics/kibana/actions';
import { KIBANA_MESSAGES } from '../analytics/kibana/constants';
import { createPIP, setPipRaisedHands, setPipStatus, setPipStreamToLocalVideoElement, setPipTileViewCanvases, setPipTileViewList, updateUserInTileViewList } from './actions';
import { STATUSES, WAITING_VIDEO_TIMEOUT } from './constants';
import { createTileViewCanvases, formatRaisedHands, getCustomListTileView, getSelectedParticipantId, isPipPlaying, isTileViewEnabled, updateCanvas, updateMainVideoStream, updateStaticUserCountName } from './function';
const mediaSession = navigator.mediaSession;
StateListenerRegistry.register(
/* selector */ state => state['wildix/features/PiP'].pipStatus, 
/* listener */ (pipStatus, { dispatch, getState }, prevStatus) => {
    const state = getState();
    console.warn(pipStatus, '[wildix/features/PiP].pipStatus');
    if (pipStatus === STATUSES.NOT_STARTED || pipStatus === prevStatus) {
        return;
    }
    if (pipStatus === STATUSES.LOADING) {
        updateCanvas({
            state: getState()
        });
    }
    if (pipStatus === STATUSES.PLAYING) {
        dispatch(setPipRaisedHands(formatRaisedHands(state)));
        const tracks = state['features/base/tracks'];
        const localVideoTrack = getLocalVideoTrack(tracks)?.jitsiTrack;
        const participantCount = getParticipantCount(state);
        if (localVideoTrack) {
            dispatch(setPipStreamToLocalVideoElement(localVideoTrack.stream));
        }
        if (isTileViewEnabled(state)) {
            dispatch(setPipTileViewList(getCustomListTileView(state)));
        }
        else if (participantCount > 1) {
            updateMainVideoStream(state, dispatch);
        }
        else {
            updateCanvas({
                state: getState()
            });
        }
    }
    else if (pipStatus === STATUSES.STOPPED) {
        // @ts-ignore
        window.cancelAnimationFrame(APP.pipAnimationId);
        if (document.pictureInPictureElement) {
            document?.exitPictureInPicture();
        }
    }
    // @ts-ignore
    dispatch(sendStatsToKibana([{
            isPipPlaying: isPipPlaying(state),
            pipStatus
        }], KIBANA_MESSAGES.PictureInPicture));
});
StateListenerRegistry.register(
/* selector */ state => state['wildix/features/PiP'].tileViewList, 
/* listener */ (tileViewList, { getState }) => {
    const state = getState();
    if (!isPipPlaying(state)) {
        return;
    }
    if (tileViewList && isTileViewEnabled(state)) {
        updateCanvas({
            state
        });
    }
});
StateListenerRegistry.register(
/* selector */ state => state['wildix/features/PiP'].mainVideo, 
/* listener */ (mainVideo, { getState }, prevVideo) => {
    const state = getState();
    const { isPipEventsEmitted } = state['wildix/features/PiP'];
    if (!isPipEventsEmitted || !mainVideo) {
        return;
    }
    console.warn(mainVideo, prevVideo, 'mainVideo, prevVideo');
    updateCanvas({
        state: getState()
    });
});
StateListenerRegistry.register(
/* selector */ state => state['wildix/features/PiP'].virtualVideoEl, 
/* listener */ (virtualVideoEl, { dispatch, getState }) => {
    if (!virtualVideoEl) {
        return;
    }
    virtualVideoEl?.addEventListener('enterpictureinpicture', async () => {
        const localState = getState();
        const tracks = localState['features/base/tracks'];
        const isVideoMuted = !isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO);
        const isAudioMuted = !isLocalTrackMuted(tracks, MEDIA_TYPE.AUDIO);
        mediaSession.setCameraActive(isVideoMuted);
        mediaSession.setMicrophoneActive(isAudioMuted);
    });
    virtualVideoEl?.addEventListener('leavepictureinpicture', () => {
        // Video left Picture-in-Picture mode.
        dispatch(setPipStatus(STATUSES.STOPPED));
    });
});
StateListenerRegistry.register(
/* selector */ state => state['wildix/features/PiP'].isPipEventsEmitted, 
/* listener */ async (isPipEventsEmitted, { dispatch, getState }) => {
    if (!isPipEventsEmitted) {
        return;
    }
    dispatch(setPipTileViewCanvases(createTileViewCanvases(getState())));
    try {
        mediaSession.setActionHandler('hangup', async () => {
            if (document.pictureInPictureElement) {
                document?.exitPictureInPicture();
            }
            dispatch(hangup());
        });
        mediaSession.setActionHandler('togglecamera', () => {
            const stateLocal = getState();
            const updatedTracks = stateLocal['features/base/tracks'];
            const isLocalVideoMuted = isLocalTrackMuted(updatedTracks, MEDIA_TYPE.VIDEO);
            mediaSession.setCameraActive(isLocalVideoMuted);
            dispatch(muteLocal(!isLocalVideoMuted, MEDIA_TYPE.VIDEO));
        });
        mediaSession.setActionHandler('togglemicrophone', () => {
            const stateLocal = getState();
            const updatedTracks = stateLocal['features/base/tracks'];
            const isLocalAudioMuted = isLocalTrackMuted(updatedTracks, MEDIA_TYPE.AUDIO);
            mediaSession.setMicrophoneActive(isLocalAudioMuted);
            dispatch(muteLocal(!isLocalAudioMuted, MEDIA_TYPE.AUDIO));
        });
    }
    catch (e) {
        console.warn(e);
    }
});
StateListenerRegistry.register(
/* selector */ state => isLocalTrackMuted(state['features/base/tracks'], MEDIA_TYPE.VIDEO), 
/* listener */ async (muted, { getState }) => {
    const state = getState();
    if (isPipPlaying(state)) {
        const isAudioOnly = Boolean(state['features/base/audio-only'].enabled);
        if (!isAudioOnly) {
            updateCanvas({
                state,
                isUserVideoMuted: muted
            });
        }
        mediaSession.setCameraActive(!muted);
    }
});
StateListenerRegistry.register(
/* selector */ state => isLocalTrackMuted(state['features/base/tracks'], MEDIA_TYPE.AUDIO), 
/* listener */ (muted, { getState }) => {
    const state = getState();
    if (isPipPlaying(state)) {
        updateCanvas({
            state
        });
        mediaSession.setMicrophoneActive(!muted);
    }
});
StateListenerRegistry.register(state => state['features/base/conference'].conference, 
/* listener */ (conference, { dispatch, getState }, prevConference) => {
    if (!conference && prevConference) {
        if (isPipPlaying(getState())) {
            try {
                if (document.pictureInPictureElement) {
                    document?.exitPictureInPicture();
                }
                // @ts-ignore
                window.cancelAnimationFrame(APP.pipAnimationId);
            }
            catch (e) {
                console.warn('exitPictureInPicture by kick out or hangup');
            }
        }
    }
    if (!conference) {
        return;
    }
    dispatch(createPIP());
    conference.on(JitsiConferenceEvents.TRACK_ADDED, async (track) => {
        const state = getState();
        const { tileViewList } = state['wildix/features/PiP'];
        const { participantId } = state['features/large-video'];
        if (!isPipPlaying(state) || (track.isLocal() && track.type === MEDIA_TYPE.AUDIO)) {
            return;
        }
        if (track.isLocal() && track.videoType !== VIDEO_TYPE.DESKTOP) {
            dispatch(setPipStreamToLocalVideoElement(track.stream));
            return;
        }
        const userIdByTrack = track.getParticipantId();
        if (tileViewList?.[userIdByTrack] && isTileViewEnabled(state)) {
            if (track.type === MEDIA_TYPE.AUDIO) {
                dispatch(updateUserInTileViewList(userIdByTrack, {
                    isAudioStopped: track.isMuted()
                }));
            }
            else if (track.type === MEDIA_TYPE.VIDEO) {
                dispatch(updateUserInTileViewList(userIdByTrack, {
                    isVideoPlaying: !track.isMuted(),
                    videoTrack: track,
                    videoTrackID: userIdByTrack
                }));
            }
            return;
        }
        if (getSelectedParticipantId(state, participantId) !== userIdByTrack) {
            return;
        }
        if (!track.isLocal() && track.type === MEDIA_TYPE.VIDEO) {
            updateMainVideoStream(state, dispatch);
        }
        else if (track.type === MEDIA_TYPE.AUDIO) {
            updateCanvas({
                state,
                isUserAudioMuted: track.isMuted()
            });
        }
    });
    conference.on(JitsiConferenceEvents.TRACK_MUTE_CHANGED, (track) => {
        const state = getState();
        const { tileViewList } = state['wildix/features/PiP'];
        const { participantId } = state['features/large-video'];
        if (!isPipPlaying(state)) {
            return;
        }
        if (track.isLocal() && track.type === MEDIA_TYPE.VIDEO) {
            if (!track.isMuted()) {
                dispatch(setPipStreamToLocalVideoElement(track.stream));
            }
        }
        const userIdByTrack = track.getParticipantId();
        if (tileViewList?.[userIdByTrack] && isTileViewEnabled(state)) {
            if (track.type === MEDIA_TYPE.AUDIO) {
                dispatch(updateUserInTileViewList(userIdByTrack, {
                    isAudioStopped: track.isMuted()
                }));
            }
            else if (track.type === MEDIA_TYPE.VIDEO) {
                dispatch(updateUserInTileViewList(userIdByTrack, {
                    isVideoPlaying: !track.isMuted(),
                    videoTrack: track,
                    videoTrackID: userIdByTrack
                }));
            }
            return;
        }
        if (getSelectedParticipantId(state, participantId) !== userIdByTrack) {
            return;
        }
        if (track.type === MEDIA_TYPE.AUDIO) {
            updateCanvas({
                state,
                isUserAudioMuted: track.isMuted()
            });
        }
        const { remoteScreenShares } = state['features/video-layout'];
        if (track.type === MEDIA_TYPE.VIDEO && remoteScreenShares.length <= 0) {
            updateCanvas({
                state,
                mainVideoState: track.isMuted()
            });
        }
    });
    conference.on(JitsiConferenceEvents.USER_JOINED, () => {
        const state = getState();
        const { tileViewList, tileViewMaxUsers } = state['wildix/features/PiP'];
        if (!isPipPlaying(state) || !isTileViewEnabled(state)) {
            return;
        }
        if (Object.keys(tileViewList)?.length - 1 === tileViewMaxUsers) {
            updateStaticUserCountName(state);
        }
        else {
            dispatch(setPipTileViewList(getCustomListTileView(state)));
        }
    });
    conference.on(JitsiConferenceEvents.USER_LEFT, (id) => {
        const state = getState();
        if (!isPipPlaying(state)) {
            return;
        }
        // Handle tile view update.
        const { tileViewList, tileViewMaxUsers } = state['wildix/features/PiP'];
        const userID = conference?.myUserId();
        if (!isTileViewEnabled(state) || userID === null) {
            return;
        }
        // @ts-ignore
        if (tileViewList?.[id] || Object.keys(tileViewList)?.length - 1 === tileViewMaxUsers) {
            dispatch(setPipTileViewList(getCustomListTileView(state)));
        }
        else {
            updateStaticUserCountName(state);
        }
    });
    conference.on(JitsiConferenceEvents.DOMINANT_SPEAKER_CHANGED, (id) => {
        const state = getState();
        if (!isPipPlaying(state) || !isTileViewEnabled(state)) {
            return;
        }
        dispatch(setPipTileViewList(getCustomListTileView(state, id)));
    });
});
StateListenerRegistry.register(
/* selector */ state => state['features/large-video'].participantId, 
/* listener */ (participantId, { dispatch, getState }) => {
    const state = getState();
    if (isPipPlaying(state) && participantId !== 'local') {
        const localParticipantId = getLocalParticipant(state)?.id;
        const largeVideoParticipant = getParticipantById(state, participantId ?? '');
        const videoTrack = getVideoTrackByParticipant(state, largeVideoParticipant);
        const isLocalScreenshareOnLargeVideo = largeVideoParticipant?.id?.includes(localParticipantId ?? '')
            && videoTrack?.videoType === VIDEO_TYPE.DESKTOP;
        if (isLocalScreenshareOnLargeVideo) {
            setTimeout(() => {
                updateCanvas({
                    state: getState(),
                    isLocalScreenShare: true
                });
            }, WAITING_VIDEO_TIMEOUT);
        }
        else if (!isTileViewEnabled(state)) {
            updateMainVideoStream(state, dispatch);
        }
    }
});
StateListenerRegistry.register(
/* selector */ state => state['features/video-layout'], 
/* listener */ ({ tileViewEnabled }, { dispatch, getState }) => {
    const state = getState();
    if (isPipPlaying(state)) {
        if (tileViewEnabled) {
            dispatch(setPipTileViewList(getCustomListTileView(state)));
        }
        else if (!isTileViewEnabled(state)) {
            updateMainVideoStream(state, dispatch);
        }
    }
});
StateListenerRegistry.register(
/* selector */ state => state['features/base/audio-only'].enabled, 
/* listener */ (value, { dispatch, getState }) => {
    const state = getState();
    if (isPipPlaying(state)) {
        if (isTileViewEnabled(state)) {
            dispatch(setPipTileViewList(getCustomListTileView(state)));
        }
        else {
            updateCanvas({
                state
            });
        }
    }
});
StateListenerRegistry.register(state => state['features/base/participants'].raisedHandsQueue, (raisedHandsQueue, { dispatch, getState }) => {
    const state = getState();
    if (isPipPlaying(state)) {
        dispatch(setPipRaisedHands(formatRaisedHands(state)));
    }
});
StateListenerRegistry.register(
/* selector */ state => state['wildix/features/PiP'].listUsersRaisedHands, 
/* listener */ (listUsersRaisedHands, { getState }) => {
    const state = getState();
    if (isPipPlaying(state)) {
        updateCanvas({
            state
        });
    }
});
